//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {startHandleAndPaiDan} from '../../../../api/workOrder'
import {WorkOrderSource, WorkOrderType} from '../../../../store/entities/workOrder'

export default {
    name: "page-PaiDan-view",
    data() {
        return {
            WorkOrderSource,
            WorkOrderType,
            dispatchPopup: false,
            paiGongPopup: false,
            saving: false,
            paiDanInputDto: {
                smsChecked: false
            },
            departments: [],
            departmentUser: [],
            organizationUnitAllUsers: [],
            showDispachist: false,
            showDepartmentUser: false,
            wuYeUserPopup: false,
            wuYeUsers: [],
            paiDanReturnOrderPopup: false,
            paiDanReturnOrder: {}
        }
    },
    computed: {
        workOrderInfo() {
            return this.$store.state.workOrder.workOrderInfo;
        },
        // buildingRepairerInfo() {
        //     return this.$store.state.workOrder.buildingRepairerInfo;
        // }
    },
    methods: {
        /*派单*/
        onSavePaiDan() {
            const vm = this;
            vm.paiDanInputDto.workOrderId = vm.workOrderInfo.id;
            vm.saving = true;
            abp.ajax.post('/api/services/app/WorkOrder/MSavePaiDan', this.paiDanInputDto).then(res => {
                vm.dispatchPopup = false;
                vm.$emit('handleSuccess')
            }).finally(() => {
                this.saving = false;
            });
        },
        /*受理+派单*/
        onStartHandleAndPaiDan() {
            const vm = this;
            vm.paiDanInputDto.workOrderId = vm.workOrderInfo.id;
            vm.saving = true;
            startHandleAndPaiDan(this.paiDanInputDto).then(res => {
                vm.dispatchPopup = false;
                vm.$emit('handleSuccess')
            }).finally(() => {
                vm.saving = false;
            });
        },

        onSavePaiGong() {
            const vm = this;
            this.paiDanInputDto.workOrderId = this.workOrderInfo.id;
            this.saving = true;
            abp.ajax.post('/api/services/app/WorkOrder/MSavePaiGong', this.paiDanInputDto).then(res => {
                vm.$emit('handleSuccess')
                vm.paiGongPopup = false;
            }).finally(() => {
                this.saving = false;
            });
        },

        onPaidanDepartmentConfirm(val) {
            // console.log(val)
            this.paiDanInputDto.departmentId = val.id;
            this.paiDanInputDto.departmentName = val.name;
            this.paiDanInputDto.userId = 0;
            this.paiDanInputDto.name = '';
            this.paiDanInputDto.phoneNumber = '';
            this.departmentUser = [];
            this.getDepartmentUser(val.id);
            this.showDispachist = false;
        },
        onPaidanUserConfirm(val) {
            // console.log(val);
            this.paiDanInputDto.userId = val.id;
            this.paiDanInputDto.name = val.name;
            this.paiDanInputDto.phoneNumber = val.phoneNumber;
            this.showDepartmentUser = false;

        },
        showPaiGongPopup() {
            this.paiDanInputDto = {};
            this.paiGongPopup = true;
            if (this.workOrderInfo.dutyParty === 1) {
                this.getWuYeWorkers()
            } else if (this.workOrderInfo.dutyParty === 2) {
                this.getWeiBaoWorkers()
            }
        },
        showDispatchPopup() {
            this.paiDanInputDto = {};
            this.dispatchPopup = true;
            // console.log('showDispatchPopup')
            if (this.workOrderInfo.workOrderType !== 2) {
                this.getDepartments(); //获取部门
            } else {
                this.getWuYeWorkers();
            }
        },

        onCancel() {
            this.dispatchPopup = false;
        },

        showWeixiuWorker() {
            this.showDepartmentUser = true;
        },

        /*物业维修工程师*/
        getWuYeWorkers() {
            if (this.workOrderInfo.organizationId <= 0) {
                return
            }
            abp.ajax.get('api/services/app/OrganizationUnit/GetWuYeWorkerUsers?organizationId=' + this.workOrderInfo.organizationId).then(res => {
                this.organizationUnitAllUsers = [];
                this.organizationUnitAllUsers.push(...res.data.result)
                this.organizationUnitAllUsers.forEach(item => {
                    item.text = item.name;
                })
            }).finally(() => {

            });

            // if (this.workOrderInfo.dutyParty === 1) {
            //     this.organizationUnitAllUsers = [];
            //     this.organizationUnitAllUsers.push({
            //         id: this.buildingRepairerInfo.workerUserId,
            //         name: this.buildingRepairerInfo.workerUserName,
            //         phoneNumber: this.buildingRepairerInfo.workerUserPhoneNumber
            //     })
            //     this.organizationUnitAllUsers.forEach(item => {
            //         item.text = item.name;
            //     })
            // }

        },

        /*维保维修工程师*/
        getWeiBaoWorkers() {
            if (this.workOrderInfo.organizationId <= 0) {
                return
            }
            abp.ajax.get('api/services/app/OrganizationUnit/GetWeiBaoWorkerUsers?organizationId=' + this.workOrderInfo.organizationId).then(res => {
                this.organizationUnitAllUsers = [];
                this.organizationUnitAllUsers.push(...res.data.result)
                this.organizationUnitAllUsers.forEach(item => {
                    item.text = item.name;
                })
            }).finally(() => {

            });
            // if (this.workOrderInfo.dutyParty === 2) {
            //     this.organizationUnitAllUsers = [];
            //     this.organizationUnitAllUsers.push({
            //         id: this.buildingRepairerInfo.weiBaoWorkerUserId,
            //         name: this.buildingRepairerInfo.weiBaoWorkerUserName,
            //         phoneNumber: this.buildingRepairerInfo.weiBaoWorkerUserPhoneNumber
            //     })
            //     this.organizationUnitAllUsers.forEach(item => {
            //         item.text = item.name;
            //     })
            // }
        },

        getDepartments() {
            if (this.workOrderInfo.organizationId === 0 || this.workOrderInfo.organizationId === undefined) {
                // this.$toast.fail("项目没有绑定组织结构")
                return;
            }
            abp.ajax.get('/api/services/app/OrganizationUnit/GetDepartmentsByParentId?parentId=' + this.workOrderInfo.organizationId).then(res => {
                this.departments = [];
                this.departments = res.data.result;

            }).finally(() => {
            });
        },

        getDepartmentUser(organizationId) {
            if (this.workOrderInfo.organizationId === 0) {
                // this.$toast.fail("项目没有绑定组织结构")
                return;
            }
            abp.ajax.get('/api/services/app/OrganizationUnit/GetDepartmentUser?organizationId=' + organizationId).then(res => {
                this.departmentUser = {};
                this.departmentUser = res.data.result;
                this.departmentUser.forEach(item => {
                    item.text = item.name;
                })

            }).finally(() => {
            });
        },

        geWuYeUser() {
            const vm = this;
            if (this.workOrderInfo.organizationId <= 0) {
                return;
            }
            abp.ajax.get('api/services/app/OrganizationUnit/GetWuYeUsers?organizationId=' + vm.workOrderInfo.organizationId).then(res => {
                vm.wuYeUsers = [];
                vm.wuYeUsers.push(...res.data.result);
                vm.wuYeUsers.forEach(item => {
                    item.text = item.name;
                });
            });
            // vm.wuYeUsers = [];
            // vm.wuYeUsers.push({
            //     id: vm.buildingRepairerInfo.userId,
            //     name: vm.buildingRepairerInfo.name,
            //     phoneNumber: vm.buildingRepairerInfo.phoneNumber
            // });
            // vm.wuYeUsers.forEach(item => {
            //     item.text = item.name;
            // });
        },

        onShowWuYeUserPopup() {
            this.geWuYeUser();
            this.wuYeUserPopup = true;
        },

        onWuYeUserPopupConfirm(val) {
            this.paiDanInputDto.userId = val.id;
            this.paiDanInputDto.name = val.name;
            this.paiDanInputDto.phoneNumber = val.phoneNumber;
            this.wuYeUserPopup = false;
        },

        /*退单*/
        onPaiDanReturnOrder() {
            const vm = this;
            vm.paiDanReturnOrder.workOrderId = vm.workOrderInfo.id;
            vm.saving = true
            abp.ajax.post('/api/services/app/WorkOrder/MPaiDanReturnOrder', vm.paiDanReturnOrder).then(res => {
                vm.paiDanReturnOrderPopup = false;
                vm.$emit('handleSuccess')
            }).finally(() => {
                vm.saving = false
            })
        },
        showPaiDanReturnOrderPopup() {
            this.paiDanReturnOrder = {}
            this.paiDanReturnOrderPopup = true;
        }
    },
    created() {

    }
}
